import {
    GridType,
    ScorecardGridDirectType,
} from '../core/template-definition.model';

/** @deprecated should be called whenever ScorecardTab.selectedScorecard is assigned */
export function determineDefaultDirectReportGrid(
    directReportGrids: ScorecardGridDirectType[],
    preferred: GridType,
): GridType {
    if (!directReportGrids) {
        return preferred;
    }
    // ScorecardGridDirectType.gridType should be valid, but check for nulls anyway
    const defaultView =
        directReportGrids.find((e) => e.gridType === preferred) ||
        directReportGrids.find((e) => e.isDefault);
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (defaultView && defaultView.gridType != null) {
        return defaultView.gridType;
    }
    if (
        directReportGrids.length !== 0 &&
        directReportGrids[0].gridType != null
    ) {
        return directReportGrids[0].gridType;
    }
    return preferred;
}
